<div
  *ngIf="showFlash"
  class="o-flash o-flash--large"
  [ngClass]="flashClass"
  #flash
>
  {{ text }}
</div>
